import styles from './skeletons.module.scss'

export default function CompanyInfoSkeleton() {
  return (
    <div className={styles.companyInfoSkeleton}>
      <div className={styles.header}>企业信息</div>
      <div className={styles.imageSkeleton}></div>
      <div className={styles.infoContent}>
        <div className={styles.infoItemSkeleton}></div>
        <div className={styles.infoItemSkeleton} style={{ width: 150 }}></div>
        <div className={styles.infoItemSkeleton} style={{ width: 150 }}></div>
      </div>
    </div>
  )
}
import styles from './skeletons.module.scss'

export default function CompanyInfoSkeleton() {
  return (
    <div className={styles.companyInfoSkeleton}>
      <div className={styles.header}>企业信息</div>
      <div className={styles.imageSkeleton}></div>
      <div className={styles.infoContent}>
        <div className={styles.infoItemSkeleton}></div>
        <div className={styles.infoItemSkeleton} style={{ width: 150 }}></div>
        <div className={styles.infoItemSkeleton} style={{ width: 150 }}></div>
      </div>
    </div>
  )
}
